import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the referrer-teams endpoint.
 */
export function buildReferrerTeamsConfig(partner_id: string, userUuid?: string): ApiCallConfig {
  return {
    method: HTTP_METHODS.GET,
    endpoint: INTERNAL_API_ENDPOINTS.REFERRER_TEAMS,
    queryParams: {
      partner_id,
      ...(userUuid ? { user_uuid: userUuid } : {}),
    },
  };
}
